import { AdminLayout } from "@/components/layouts/admin-layout"
import { usePage } from "@inertiajs/react"
import { MainContainer } from "@/components/ui/container"
import { ProfileForm } from "@/components/features/profiles/profile-form"

type SharedUser = {
  name: string
  email: string
  initials: string
  avatar: string | null
}

export default function AdminProfilesEdit() {
  const { user } = usePage<{ user: SharedUser | null }>().props

  if (!user) return null

  return (
    <AdminLayout>
      <MainContainer size="xs">
        <ProfileForm defaultValues={{ name: user.name, email: user.email }} />
      </MainContainer>
    </AdminLayout>
  )
}
